<template>
    <jet-authentication-card>
        <template #logo>
            <jet-authentication-card-logo />
        </template>

        <div class="mb-4 text-sm text-iron-600">
            <template v-if="!recovery">{{
                $t("auth.two_factor.description")
            }}</template>

            <template v-else>{{
                $t("auth.two_factor.recovery_description")
            }}</template>
        </div>

        <jet-validation-errors class="mb-4" />

        <form @submit.prevent="submit">
            <div v-if="!recovery">
                <jet-label for="code" :value="$t('auth.two_factor.code')" />
                <jet-input
                    id="code"
                    ref="code"
                    v-model="form.code"
                    type="text"
                    inputmode="numeric"
                    class="mt-1 block w-full"
                    autofocus
                    autocomplete="one-time-code"
                />
            </div>

            <div v-else>
                <jet-label
                    for="recovery_code"
                    :value="$t('auth.two_factor.recovery_code')"
                />
                <jet-input
                    id="recovery_code"
                    ref="recovery_code"
                    v-model="form.recovery_code"
                    type="text"
                    class="mt-1 block w-full"
                    autocomplete="one-time-code"
                />
            </div>

            <div class="mt-4 flex items-center justify-end">
                <button
                    type="button"
                    class="text-sm text-iron-600 hover:text-iron-900 cursor-pointer underline"
                    @click.prevent="toggleRecovery"
                >
                    <template v-if="!recovery">{{
                        $t("auth.two_factor.user_recovery_code")
                    }}</template>

                    <template v-else>{{
                        $t("auth.two_factor.use_auth_code")
                    }}</template>
                </button>

                <jet-button
                    class="ml-4"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    >{{ $t("auth.two_factor.log_in") }}</jet-button
                >
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from "../../Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "../../Jetstream/AuthenticationCardLogo.vue";
import JetButton from "../../Jetstream/Button.vue";
import JetInput from "../../Jetstream/Input.vue";
import JetLabel from "../../Jetstream/Label.vue";
import JetValidationErrors from "../../Jetstream/ValidationErrors.vue";

export default {
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetLabel,
        JetValidationErrors,
    },

    data() {
        return {
            recovery: false,
            form: this.$inertia.form({
                code: "",
                recovery_code: "",
            }),
        };
    },

    methods: {
        toggleRecovery() {
            this.recovery ^= true;

            this.$nextTick(() => {
                if (this.recovery) {
                    this.$refs.recovery_code.focus();
                    this.form.code = "";
                } else {
                    this.$refs.code.focus();
                    this.form.recovery_code = "";
                }
            });
        },

        submit() {
            this.form.post(this.route("two-factor.login"));
        },
    },
};
</script>
